import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class State {

    loadingChange: Subject<boolean> = new Subject<boolean>();
    private loading: boolean;

    constructor() {
        // Listen to changes
        this.loadingChange.subscribe((value) => {
            this.loading = value;
        });
    }

    // Loading data
    public setLoading(loading: boolean) {
        this.loadingChange.next(loading);
    }
    public getLoading(): boolean {
        return this.loading;
    }

}
